import {takeWhile} from 'rxjs/operators';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, NgZone} from '@angular/core';
import {DetailControlOption, ValuesObject} from '../detail-tabconfig';
import {AbstractControlComponent} from './abstract-control';
import {Observable} from 'rxjs';
import {ViewTabComponent} from '../viewtab.component';
import {optioncontrolRequired} from './validators/optioncontrol-required-validator';
import {ErrorService} from '../../../error/error.service';

@Component({
  selector: 'ctrl-colorpicker',
  template: `
    @if (
      (getCaughtObservable(isEnabled) | async) &&
      formControl.touched &&
      formControl.hasError('required')
    ) {
      <mat-error>
        <language key="ControlErrorRequired" defaultValue="This field is required."></language>
      </mat-error>
    }
  `,
  styles: [
    `
      /* TODO(mdc-migration): The following rule targets internal classes of radio that may no longer apply for the MDC version. */
      mat-radio-button {
        margin-right: 20px;
      } /* TODO(mdc-migration): The following rule targets internal classes of radio that may no longer apply for the MDC version. */
      :host ::ng-deep .mat-radio-label {
        align-items: center;
      } /* TODO(mdc-migration): The following rule targets internal classes of radio that may no longer apply for the MDC version. */
      :host ::ng-deep .mat-radio-container {
        top: -1px;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CtrlColorpickerComponent extends AbstractControlComponent {
  constructor(
    _parent: ViewTabComponent,
    changeDetector: ChangeDetectorRef,
    _ngZone: NgZone,
    errorService: ErrorService,
  ) {
    super(_parent, null, null, changeDetector, _ngZone, errorService);
  }

  @Input() objectType: string;

  protected initValidators(): void {
    if (this._config == null || this.formControl == null) {
      throw Error('Initialized target too early.');
    }

    this._config
      .getBooleanPropertyValues('Required')
      .pipe(takeWhile(() => this.alive))
      .subscribe(required => {
        if (required === true) {
          this.formControl.setValidators([optioncontrolRequired()]);
        } else {
          this.formControl.clearValidators();
        }
        this.formControl.updateValueAndValidity({emitEvent: false});
      });
  }
  private color = '';

  protected formatSource(source: any): any {
    if (source === '' || source == null) source = DetailControlOption.NullValueOverwrite;
    if (typeof source === 'boolean') {
      return null;
    }
    return source;
  }

  protected formatTarget(value: any): any {
    if (value === DetailControlOption.NullValueOverwrite) value = null;
    return value;
  }
}
